export const createNewEventStyle = {
	wrapper: {
		maxWidth: '970px',
		width: '100%',
		margin: '0 auto',
		paddingBottom: '120px',

		'@media (max-width: 1199.98px)': {
			padding: '0 16px',
			paddingBottom: '120px',
		},

		'@media (max-width: 639.98px)': {
			padding: '0 12px',
			paddingBottom: '140px',
		},
	},

	stepper: {
		width: '100%',
		margin: '40px 0',
		textTransform: 'capitalize',

		'@media (max-width: 1199.98px)': {
			margin: '24px 0',
		},

		'@media (max-width: 639.98px)': {
			margin: '16px 0',
		},

		'& .MuiTypography-root': {
			lineHeight: '28px',
		},
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 20px',
			width: '100%',

			'& > div': {
				maxWidth: '370px',
				margin: '0 auto',

				'&> div svg path': {
					fill: 'var(--success-500)',
				},
			},
		},
	},
};
